module.exports = __webpack_public_path__ + "static/media/icon-mentoring.afb4d75a.svg";